<template>
    <button
        v-tooltip="{ message: tooltip ?? null, position: 'bottom' }"
        type="button"
        class="forms__field_input--wysiwyg__button"
        :class="{
            'forms__field_input--wysiwyg__button--active': active,
            'forms__field_input--wysiwyg__button--disabled': disabled,
        }"
    >
        <slot></slot>
    </button>
</template>

<script setup lang="ts">
import { toRef } from 'vue';

interface Props {
    active?: boolean;
    disabled?: boolean;
    tooltip?: string | null;
}

const props = withDefaults(defineProps<Props>(), {
    active: false,
    disabled: false,
    tooltip: null,
});

const active = toRef(props, 'active');
const disabled = toRef(props, 'disabled');
const tooltip = toRef(props, 'tooltip');
</script>
